var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-button",on:{"click":_vm.login}},[_vm._m(0),_c('p',{staticClass:"btn-text"},[_c('b',[_vm._v(_vm._s(_vm.$t('registration.google')))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-icon-wrapper"},[_c('img',{staticClass:"google-icon",attrs:{"src":"https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"}})])
}]

export { render, staticRenderFns }